export enum ComponentsEnum {
  PARADOX,
  EXPERIMENT,
  WHAT,
  HOW,
  ALLY,
  OPPORTUNITY,
  PARTNERS
}
